import { useQuery } from 'react-query';
import { quickVideoKeys } from './quickVideoKeys';
import { EXPRESS_API } from 'configs/api/expressApi';
import { IQuickVideo } from './types';
import { useToastError } from 'lib/hooks';

interface IGetQuickVideo {
  quickVideoId: number;
  enabled: boolean;
}

const getQuickVideo = async (quickVideoId: number): Promise<IQuickVideo> => {
  return (await EXPRESS_API.get(`quick-videos/${quickVideoId}`)).data;
};

export const useGetQuickVideo = ({ quickVideoId, enabled }: IGetQuickVideo) => {
  const { showError } = useToastError();
  return useQuery(
    quickVideoKeys.single(quickVideoId),
    () => getQuickVideo(quickVideoId),
    {
      enabled,
      onError: err => {
        showError(err);
      },
    }
  );
};
